export const ALL_USERS = 0;
export const ADMIN = 1;
export const SUPER_DISTRIBUTOR = 2;
export const DISTRIBUTOR = 3;
export const RETAILER = 4;
export const API_USER = 5;
export const SUPPORT_USER = 6;
export const CLIENT_CODE = 7;
export const ACCOUNTANT = 9;
export const SDFOS = 10;
export const DFOS = 11;
export const DEACTIVE_USERS = 999;
